import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import ActionButton from "controls/global/action-button";
import DialogTitleCloseButton from "controls/global/dialog-close-btn/DialogTitleCloseButton";
import React, {
  ReactNode,
  useEffect,
  useState,
} from "react";
import { colors } from "theme/defaultStyle";
import { DialogType } from "utils/custom-hooks/useDialogStyles";
import {
  StewartDialog,
  StewartDialogActions,
  StewartDialogContent,
  StewartDialogTitle
} from "../stewart-dialog/StewartDialog";
import { styled } from "@mui/material";


type Props = {
  singleActionButton?: boolean;
  singleActionButtonText?: string;
  confirmationMessage: string | ReactNode;
  isOpen: boolean;
  onYes: any;
  disableYes?: boolean;
  onNo?: any;
  disableNo?: boolean;
  buttonNoText?: string;
  cancelActionButton?: boolean;
  noActionButton?: boolean;
  onCancel?: any;
  type?: DialogType;
  width?: number;
};

const ConfirmationDialog = ({
  singleActionButton,
  singleActionButtonText,
  confirmationMessage,
  isOpen,
  onYes,
  disableYes = false,
  onNo,
  disableNo = false,
  buttonNoText,
  cancelActionButton,
  noActionButton = !singleActionButton,
  onCancel,
  type = "WARNING",
  width = 500,
}: Props) => {
  const [open, setOpen] = useState(false);
  const icons: any = {
    "ERROR": ReportProblemIcon,
    "WARNING": ErrorOutlinedIcon,
  };

  const CustomDialogContent = styled(StewartDialogContent)(
    ({ theme }) => ({
      maxHeight: "70vh", 
      overflowY: "auto",
      overflowWrap: "break-word",
    })
  );

  
  const AlertIcon = icons[type];

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  return (
    <StewartDialog
      open={open}
      width={width}
    >
      <StewartDialogTitle type={type}>
        <AlertIcon style={{ fontSize: 40, color: colors.white }} />
        { cancelActionButton && (
          <DialogTitleCloseButton onClick={onCancel}/>
        )}
      </StewartDialogTitle>
      <CustomDialogContent type={type}>
        {confirmationMessage}
      </CustomDialogContent>
      <StewartDialogActions>
        {!singleActionButton && (
          <>
            {noActionButton && (
              <ActionButton
                variant="outlined"
                color="secondary"
                onClick={onNo}
                disabled={disableNo}
                startIcon={<ClearIcon />}
              >
                {buttonNoText || "No"}
              </ActionButton>
            )}
          </>
        )}
        <ActionButton
          autoFocus
          variant="outlined"
          color="primary"
          onClick={onYes}
          disabled={disableYes}
          startIcon={<CheckIcon />}
        >
          {singleActionButtonText || "Yes"}
        </ActionButton>
      </StewartDialogActions>
    </StewartDialog>
  );
};

export default ConfirmationDialog;
